import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

export default function LanguageSelector({
  showPrompt = true,
}) {
  const {
    language,
    setLanguage,
    t,
  } = useLanguage();

  return (
    <div style={styles.wrapper}>
      {showPrompt && (
        <div style={styles.prompt}>
          🌐 {t("language.selectPrompt")}
        </div>
      )}

      <select
        aria-label={t("language.label")}
        value={language}
        onChange={(e) =>
          setLanguage(e.target.value)
        }
        style={styles.select}
      >
        <option value="en">
          🇺🇸 English
        </option>

        <option value="zh">
          🇨🇳 中文
        </option>

        <option value="es">
          🇪🇸 Español
        </option>

        <option value="ru">
          🇷🇺 Русский
        </option>
      </select>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "14px",
    flexWrap: "wrap",
  },

  prompt: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#64748b",
    whiteSpace: "nowrap",
  },

  select: {
    minWidth: "150px",
    padding: "10px 34px 10px 12px",
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#172033",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    outline: "none",
  },
};